var change = "Mudar";
var edit = "Editar";
var loading = "Carregando";
var logout = "Sair";
var support = "Central de Ajuda Digital";
var more = "Mais";
var yes = "Sim";
var no = "Não";
var exit = "Saída";
var you = "Você";
var search = "Procurar";
var pt = {
	"business-unit": "Unidade de negócio",
	"ces-administration": "Administração CES",
	change: change,
	"change-business-unit": "Alterar unidade de negócios",
	edit: edit,
	loading: loading,
	logout: logout,
	"no-application-available": "Nenhum aplicativo disponível.",
	"select-a-business-unit-to-change": "Selecione uma unidade de negócios para a qual mudar. Se a unidade de negócios não utilizar seu aplicativo atual, você será levado ao seu Perfil.",
	support: support,
	"system-administration": "Administração do Sistema",
	more: more,
	yes: yes,
	no: no,
	"you-already-switched-to": "Você já mudou para <bold>{{name}}</bold> há algum tempo. Deseja mudar <bold>{{name}}</bold> aqui?",
	"business-unit-has-changed": "A Unidade de Negócios mudou",
	exit: exit,
	"impersonated-user": "Usuário personificado",
	you: you,
	"no-business-unit-assigned": "Nenhuma unidade de negócios atribuída",
	"explore-marigold": "Explorar Marigold",
	"no-data-to-display": "Sem dados para exibir",
	search: search
};

export { change, pt as default, edit, exit, loading, logout, more, no, search, support, yes, you };
